import { render, staticRenderFns } from "./Municipio.vue?vue&type=template&id=37a6a4aa&"
import script from "./Municipio.vue?vue&type=script&lang=js&"
export * from "./Municipio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports